<template>
  <div class="schedule-message-container">
    <woot-modal
      :show="isFeatureEnabled && show"
      :on-close="onClose"
      :show-close-button="true"
      :close-on-backdrop-click="true"
    >
      <!-- Header do Modal -->
      <div class="modal-header">
        <div class="header-content">
          <div class="title-group">
            <h1 class="modal-title">Agendamento de Mensagem</h1>
          </div>
        </div>
      </div>

      <!-- Container dos blocos -->
      <div class="schedule-message">
        <!-- Coluna do Formulário -->
        <div class="form-column">
          <form
            class="schedule-message__form"
            @submit.prevent="handleSubmit"
            @click.stop
          >
            <div class="form-group">
              <label class="dark:text-slate-100">Título</label>
              <input
                v-model="title"
                type="text"
                class="form-input dark:bg-slate-700 dark:text-slate-100 dark:border-slate-600"
                placeholder="Digite um título para identificar este agendamento"
                required
              />
            </div>

            <!-- Campo de seleção de template -->
            <div class="form-group">
              <label class="dark:text-slate-100">Modelo de Mensagem</label>
              <div class="template-selector">
                <select
                  v-model="selectedTemplate"
                  class="form-input dark:bg-slate-700 dark:text-slate-100 dark:border-slate-600"
                  @change="applyTemplate"
                >
                  <option value="">Selecione um template (opcional)</option>
                  <option
                    v-for="template in templates"
                    :key="template.id"
                    :value="template"
                  >
                    {{
                      template.title ||
                      template.content.substring(0, 50) + '...'
                    }}
                  </option>
                </select>
                <div v-if="loadingTemplates" class="template-loading">
                  <span class="loading-spinner"></span>
                  <span class="loading-text">Carregando templates...</span>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label class="dark:text-slate-100">Mensagem</label>
              <textarea
                v-model="message"
                class="form-input dark:bg-slate-700 dark:text-slate-100 dark:border-slate-600"
                placeholder="Digite a mensagem que será enviada"
                required
              />
            </div>

            <div class="form-group">
              <label class="dark:text-slate-100">Selecione um canal</label>
              <select
                v-model="selectedInbox"
                class="form-input dark:bg-slate-700 dark:text-slate-100 dark:border-slate-600"
                required
              >
                <option value="">Selecione um canal</option>
                <option
                  v-for="inbox in inboxes"
                  :key="inbox.id"
                  :value="inbox.id"
                >
                  {{ inbox.name }}
                </option>
              </select>
            </div>

            <div class="form-group">
              <label class="dark:text-slate-100">Data e Hora do Envio</label>
              <input
                v-model="scheduledTime"
                type="datetime-local"
                class="form-input dark:bg-slate-700 dark:text-slate-100 dark:border-slate-600"
                required
              />
            </div>

            <div class="form-group">
              <div class="checkbox-group">
                <label class="checkbox-label">
                  <input
                    v-model="isRecurrent"
                    type="checkbox"
                    class="checkbox-input"
                  />
                  <span class="checkbox-text dark:text-slate-100">
                    Mensagem recorrente
                  </span>
                </label>
              </div>
            </div>

            <div v-if="isRecurrent" class="form-group">
              <label class="dark:text-slate-100"
                >Frequência de Recorrência</label
              >
              <select
                v-model="selectedPeriod"
                class="form-input dark:bg-slate-700 dark:text-slate-100 dark:border-slate-600"
                required
              >
                <option value="">Selecione a frequência</option>
                <option value="every_day">Todos os dias</option>
                <option value="every_day_at_time">
                  Todos os dias no mesmo horário
                </option>
                <option value="every_week">Todas as semanas</option>
                <option value="every_month">Todos os meses</option>
                <option value="every_weekday">
                  Dias úteis (Segunda a Sexta)
                </option>
                <option value="every_weekend">
                  Fins de semana (Sábado e Domingo)
                </option>
              </select>
            </div>

            <div class="modal-footer dark:border-slate-600">
              <div class="button-wrapper">
                <Button
                  variant="ghost"
                  color="slate"
                  size="sm"
                  @click="onClose"
                >
                  Cancelar
                </Button>

                <!-- Botão de Agendar -->
                <Button
                  v-if="!isEditing"
                  variant="solid"
                  color="blue"
                  size="sm"
                  type="submit"
                >
                  Agendar mensagem
                </Button>

                <!-- Botão de Salvar alterações -->
                <Button
                  v-else
                  variant="solid"
                  color="teal"
                  size="sm"
                  type="button"
                  @click="updateScheduledMessage"
                >
                  Salvar alterações
                </Button>
              </div>
            </div>
          </form>
        </div>

        <!-- Coluna da Lista de Agendamentos -->
        <div class="scheduled-list-column">
          <div class="scheduled-messages">
            <div class="scheduled-messages-header">
              <div class="header-content">
                <div class="title-group">
                  <h3 class="dark:text-slate-100">
                    Mensagens Agendadas
                    <span v-if="scheduledMessages.length > 0" class="counter">
                      {{ pendingMessagesCount }}
                    </span>
                  </h3>

                  <!-- Filtro apenas se houver mensagens -->
                  <woot-button
                    v-if="scheduledMessages.length > 0"
                    variant="clear"
                    size="small"
                    class="filter-button"
                    @click="openFilterMenu($event)"
                  >
                    <fluent-icon icon="filter" size="16" />
                  </woot-button>
                </div>
              </div>
            </div>

            <!-- Estado vazio -->
            <div v-if="scheduledMessages.length === 0" class="empty-state">
              <div class="empty-state-content">
                <svg
                  width="48"
                  height="48"
                  fill="none"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  class="empty-icon"
                >
                  <path
                    d="M17.75 3A3.25 3.25 0 0 1 21 6.25v11.5A3.25 3.25 0 0 1 17.75 21H6.25A3.25 3.25 0 0 1 3 17.75V6.25A3.25 3.25 0 0 1 6.25 3h11.5Zm1.75 5.5h-15v9.25c0 .966.784 1.75 1.75 1.75h11.5a1.75 1.75 0 0 0 1.75-1.75V8.5Zm-11.75 6a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5Zm4.25 0a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5Zm-4.25-4a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5Zm4.25 0a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5Zm4.25 0a1.25 1.25 0 1 1 0 2.5a1.25 1.25 0 0 1 0-2.5Zm1.5-6H6.25A1.75 1.75 0 0 0 4.5 6.25V7h15v-.75a1.75 1.75 0 0 0-1.75-1.75Z"
                    fill="currentColor"
                  />
                </svg>
                <p class="empty-text">Nenhuma mensagem agendada</p>
                <p class="empty-subtext">
                  As mensagens agendadas aparecerão aqui
                </p>
              </div>
            </div>

            <!-- Lista de mensagens (existente) -->
            <div v-else class="scheduled-messages-list">
              <div
                v-for="message in filteredMessages"
                :key="message.id"
                class="scheduled-message"
              >
                <!-- Cabeçalho do Card -->
                <div
                  class="message-header"
                  @click="toggleMessageExpand(message.id)"
                >
                  <div class="header-content">
                    <div class="title-section">
                      <div class="title-and-badge">
                        <span class="title">{{ message.title }}</span>
                        <span
                          class="status-badge"
                          :class="getStatusClass(message.status)"
                        >
                          <span class="pulse-dot"></span>
                          {{ getStatusText(message.status) }}
                        </span>
                      </div>
                      <fluent-icon
                        :icon="
                          expandedMessages.includes(message.id)
                            ? 'chevron-up'
                            : 'chevron-down'
                        "
                        size="14"
                        class="expand-icon"
                      />
                    </div>

                    <div class="meta-info">
                      <div class="datetime">
                        <fluent-icon icon="calendar" size="12" class="icon" />
                        {{ formatDate(message.scheduled_at) }}
                      </div>
                      <div class="inbox">
                        <fluent-icon icon="chat" size="12" class="icon" />
                        {{ getInboxName(message.inbox_id) }}
                      </div>
                      <!-- Indicador de Recorrência -->
                      <div v-if="message.is_recurrent" class="recurrence">
                        <fluent-icon
                          icon="arrow-clockwise"
                          size="12"
                          class="icon"
                        />
                        <span class="recurrence-text">{{
                          getPeriodText(message.period)
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Conteúdo Expansível -->
                <div
                  v-show="expandedMessages.includes(message.id)"
                  class="message-expandable"
                >
                  <div class="message-preview">
                    <div class="preview-header">
                      <fluent-icon icon="chat" size="14" class="preview-icon" />
                      <span>Mensagem Agendada</span>
                    </div>
                    <div class="preview-content">
                      {{ message.message }}
                    </div>
                  </div>

                  <div class="actions">
                    <woot-button
                      variant="clear"
                      size="small"
                      class="action-button resend"
                      @click.stop.prevent="handleResend(message)"
                    >
                      <fluent-icon icon="arrow-clockwise" size="12" />
                      Reenviar
                    </woot-button>
                    <woot-button
                      variant="clear"
                      size="small"
                      class="action-button edit"
                      @click.stop.prevent="handleEdit(message)"
                    >
                      <fluent-icon icon="edit" size="12" />
                      Editar
                    </woot-button>
                    <woot-button
                      variant="clear"
                      size="small"
                      class="action-button delete"
                      @click.stop="deleteMessage(message.id)"
                    >
                      <fluent-icon icon="delete" size="12" />
                      Excluir
                    </woot-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </woot-modal>

    <!-- Modal de Confirmação de Exclusão -->
    <woot-modal
      :show="showDeleteConfirmation"
      :on-close="closeDeleteModal"
      :show-close-button="true"
      :close-on-backdrop-click="true"
    >
      <div class="delete-confirmation-modal">
        <div class="modal-header">
          <div class="header-content">
            <div class="title-group">
              <h1 class="modal-title">Excluir agendamento</h1>
            </div>
          </div>
        </div>

        <div class="modal-content">
          <p class="modal-message">
            Tem certeza que deseja excluir este agendamento? Esta ação não pode
            ser desfeita.
          </p>
        </div>

        <div class="modal-footer">
          <div class="button-wrapper">
            <Button
              variant="ghost"
              color="slate"
              size="sm"
              @click="closeDeleteModal"
            >
              Não, manter
            </Button>
            <Button
              variant="solid"
              color="ruby"
              size="sm"
              @click="confirmDelete"
            >
              Sim, excluir
            </Button>
          </div>
        </div>
      </div>
    </woot-modal>

    <!-- Adicione isso próximo ao botão de filtro -->
    <context-menu
      :show="showFilterMenu"
      :x="filterMenuPosition.x"
      :y="filterMenuPosition.y"
      :items="filterMenuItems"
      :selected-id="statusFilter"
      @select="handleFilterSelect"
      @close="closeFilterMenu"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import ConversationApi from '../../../../api/inbox/conversation';
import FunnelAPI from '../../../../api/funnel';
import { FEATURE_FLAGS } from '../../../../featureFlags';
import ContextMenu from '../../../ui/ContextMenu.vue';
import Button from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    ContextMenu,
    Button,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    conversationId: {
      type: [Number, String],
      required: true,
    },
  },

  data() {
    return {
      title: '',
      message: '',
      selectedInbox: '',
      scheduledTime: '',
      isLoading: false,
      scheduledMessages: [],
      isScheduledMessagesOpen: true,
      isEditing: false,
      editingMessageId: null,
      enabledFeatures: {},
      showDeleteConfirmation: false,
      messageToDelete: null,
      expandedMessages: [], // Array para controlar quais mensagens estão expandidas
      statusFilter: 'all', // Novo estado para o filtro
      filterMenuItems: [
        {
          id: 'all',
          label: 'Todos os status',
          icon: 'list',
        },
        {
          id: 'pending',
          label: 'Pendentes',
          icon: 'clock',
        },
        {
          id: 'sent',
          label: 'Enviados',
          icon: 'checkmark',
        },
      ],
      showFilterMenu: false,
      filterMenuPosition: { x: 0, y: 0 },
      isRecurrent: false,
      selectedPeriod: '',
      // Novos estados para templates
      templates: [],
      selectedTemplate: null,
      loadingTemplates: false,
    };
  },

  computed: {
    ...mapGetters({
      currentChat: 'getSelectedChat',
      inboxes: 'inboxes/getInboxes',
      accountId: 'getCurrentAccountId',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      selectedFunnel: 'funnel/getSelectedFunnel',
    }),

    account() {
      return this.$store.getters['accounts/getAccount'](this.accountId);
    },

    isFeatureEnabled() {
      return this.isFeatureEnabledonAccount(
        this.accountId,
        FEATURE_FLAGS.SCHEDULE_MESSAGES
      );
    },

    pendingMessagesCount() {
      return this.scheduledMessages.filter(
        message => message.status === 'pending'
      ).length; // Contador de mensagens pendentes
    },

    filteredMessages() {
      if (this.statusFilter === 'all') {
        return this.scheduledMessages;
      }
      return this.scheduledMessages.filter(
        message => message.status === this.statusFilter
      );
    },
  },

  async mounted() {
    console.log(
      '[ScheduleMessageModal] isFeatureEnabled:',
      this.isFeatureEnabled
    );
    console.log('[ScheduleMessageModal] mounted');
    console.log(
      '[ScheduleMessageModal] enabledFeatures:',
      this.enabledFeatures
    );
    console.log(
      '[ScheduleMessageModal] isFeatureEnabled:',
      this.isFeatureEnabled
    );

    await this.fetchScheduledMessages();
    await this.fetchTemplates();
    if (!this.isFeatureEnabled) {
      console.log(
        '[ScheduleMessageModal] Feature desabilitada, fechando modal'
      );
      this.onClose();
    }
  },

  methods: {
    // Nova função para buscar templates
    async fetchTemplates() {
      try {
        this.loadingTemplates = true;
        const response = await FunnelAPI.get();
        const allTemplates = [];

        response.data.forEach(funnel => {
          Object.values(funnel.stages).forEach(stage => {
            if (stage.message_templates) {
              allTemplates.push(...stage.message_templates);
            }
          });
        });

        this.templates = allTemplates;
        console.log(
          '[ScheduleMessageModal] Templates carregados:',
          this.templates
        );
      } catch (error) {
        console.error(
          '[ScheduleMessageModal] Erro ao carregar templates:',
          error
        );
        useAlert('Erro ao carregar templates de mensagens', 'error');
      } finally {
        this.loadingTemplates = false;
      }
    },

    // Função para aplicar template selecionado
    applyTemplate() {
      if (this.selectedTemplate) {
        this.message = this.selectedTemplate.content;
        this.title =
          this.selectedTemplate.title ||
          this.selectedTemplate.content.substring(0, 50) + '...';
      }
    },

    initializeEnabledFeatures() {
      this.enabledFeatures = this.account.features;
    },

    async fetchScheduledMessages() {
      try {
        const response = await ConversationApi.getScheduledMessages(
          this.conversationId
        );
        console.log('Resposta da API:', response);

        // Acessando corretamente o array de mensagens agendadas
        this.scheduledMessages = response.data.payload || [];

        console.log('Mensagens agendadas:', this.scheduledMessages);
      } catch (error) {
        console.error('Erro ao buscar mensagens:', error);
        // Não mostrar toast quando a conversa não existir (404)
        if (error && error.response && error.response.status === 404) {
          return;
        }
        useAlert('Erro ao carregar mensagens agendadas', 'error');
      }
    },

    onClose() {
      this.$emit('close');
      this.resetForm();
    },

    resetForm() {
      console.log('Iniciando reset do formulário');
      this.title = '';
      this.message = '';
      this.selectedInbox = '';
      this.scheduledTime = '';
      this.isLoading = false;
      this.isEditing = false;
      this.editingMessageId = null;
      this.isRecurrent = false;
      this.selectedPeriod = '';
      this.selectedTemplate = null;
      console.log('Formulário resetado');
    },

    async onSubmit() {
      try {
        this.isLoading = true;
        const data = {
          scheduled_message: {
            inbox_id: this.selectedInbox,
            content: this.message,
            scheduled_at: new Date(this.scheduledTime).toISOString(),
            title: this.title,
            is_recurrent: this.isRecurrent,
            period: this.selectedPeriod,
          },
        };

        await ConversationApi.scheduleMessage({
          conversation_id: this.conversationId,
          ...data.scheduled_message,
        });

        useAlert('Mensagem agendada com sucesso', 'success');
        await this.fetchScheduledMessages();
        this.resetForm();
        this.onClose();
      } catch (error) {
        useAlert(
          'Não foi possível agendar a mensagem. Tente novamente.',
          'error'
        );
      } finally {
        this.isLoading = false;
      }
    },

    async updateScheduledMessage() {
      try {
        this.isLoading = true;
        const data = {
          inbox_id: this.selectedInbox,
          content: this.message,
          scheduled_at: new Date(this.scheduledTime).toISOString(),
          title: this.title,
          is_recurrent: this.isRecurrent,
          period: this.selectedPeriod,
        };

        await ConversationApi.updateScheduledMessage(
          this.conversationId,
          this.editingMessageId,
          data
        );

        useAlert('Agendamento atualizado com sucesso', 'success');
        await this.fetchScheduledMessages();
        this.resetForm();
        this.onClose();
      } catch (error) {
        useAlert(
          'Não foi possível atualizar o agendamento. Tente novamente.',
          'error'
        );
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(timestamp) {
      return new Date(timestamp * 1000).toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },

    getInboxName(inboxId) {
      const inbox = this.inboxes.find(i => i.id === inboxId);
      return inbox ? inbox.name : 'Caixa não encontrada';
    },

    getStatusText(status) {
      return status === 'sent' ? 'Enviado' : 'Pendente';
    },

    getStatusClass(status) {
      return {
        'status-pending': status === 'pending',
        'status-sent': status === 'sent',
      };
    },

    handleEdit(message) {
      console.log('Preenchendo formulário para edição:', message);

      this.title = message.title;
      this.message = message.message;
      this.selectedInbox = message.inbox_id;

      // Converte o timestamp para o formato datetime-local
      const date = new Date(message.scheduled_at * 1000);
      this.scheduledTime = date.toISOString().slice(0, 16);

      // Carrega dados de recorrência
      this.isRecurrent = message.is_recurrent || false;
      if (
        message.period &&
        typeof message.period === 'object' &&
        message.period.type
      ) {
        this.selectedPeriod = message.period.type;
      } else if (typeof message.period === 'string') {
        this.selectedPeriod = message.period;
      } else {
        this.selectedPeriod = '';
      }

      // Limpa template selecionado na edição
      this.selectedTemplate = null;

      this.isEditing = true;
      this.editingMessageId = message.id;
      this.isScheduledMessagesOpen = false;
    },

    async deleteMessage(id) {
      this.messageToDelete = id;
      this.showDeleteConfirmation = true;
    },

    closeDeleteModal() {
      this.showDeleteConfirmation = false;
      this.messageToDelete = null;
    },

    async confirmDelete() {
      try {
        await ConversationApi.deleteScheduledMessage(
          this.conversationId,
          this.messageToDelete
        );
        await this.fetchScheduledMessages();

        useAlert('Agendamento excluído com sucesso', 'success');
      } catch (error) {
        useAlert('Não foi possível excluir o agendamento', 'error');
      } finally {
        this.closeDeleteModal();
      }
    },

    toggleScheduledMessages() {
      this.isScheduledMessagesOpen = !this.isScheduledMessagesOpen;
    },

    handleSubmit(event) {
      if (!this.isEditing) {
        this.onSubmit();
      }
    },

    toggleMessageExpand(messageId) {
      const index = this.expandedMessages.indexOf(messageId);
      if (index === -1) {
        this.expandedMessages.push(messageId);
      } else {
        this.expandedMessages.splice(index, 1);
      }
    },

    openFilterMenu(event) {
      event.stopPropagation();
      const rect = event.target.getBoundingClientRect();
      this.filterMenuPosition = {
        x: rect.left,
        y: rect.bottom + 4,
      };
      this.showFilterMenu = true;
    },

    closeFilterMenu() {
      this.showFilterMenu = false;
    },

    handleFilterSelect(item) {
      this.statusFilter = item.id;
      this.closeFilterMenu();
    },

    async handleResend(message) {
      try {
        this.isLoading = true;

        // Calcula 5 segundos a partir do horário atual
        const now = new Date();
        const scheduledTime = new Date(now.getTime() + 5000); // 5 segundos

        const data = {
          inbox_id: message.inbox_id,
          content: message.message,
          scheduled_at: scheduledTime.toISOString(),
          title: message.title,
        };

        // Se a mensagem original era recorrente, mantém a recorrência
        if (message.is_recurrent && message.period) {
          data.is_recurrent = message.is_recurrent;
          data.period = message.period;
        }

        await ConversationApi.scheduleMessage({
          conversation_id: this.conversationId,
          ...data,
        });

        useAlert('Mensagem reenviada com sucesso para 5 segundos', 'success');
        await this.fetchScheduledMessages();
      } catch (error) {
        console.error('Erro ao reenviar mensagem:', error);
        useAlert(
          'Não foi possível reenviar a mensagem. Tente novamente.',
          'error'
        );
      } finally {
        this.isLoading = false;
      }
    },

    getPeriodText(period) {
      // Se period for um objeto JSON, extrai o tipo
      const periodType =
        typeof period === 'object' && period !== null ? period.type : period;

      switch (periodType) {
        case 'every_day':
          return 'Todos os dias';
        case 'every_day_at_time':
          return 'Todos os dias no mesmo horário';
        case 'every_week':
          return 'Todas as semanas';
        case 'every_month':
          return 'Todos os meses';
        case 'every_weekday':
          return 'Dias úteis (Segunda a Sexta)';
        case 'every_weekend':
          return 'Fins de semana (Sábado e Domingo)';
        default:
          return 'Recorrência desconhecida';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule-message-container {
  // Se necessário, adicione estilos específicos para o container
}

.schedule-message {
  display: flex;
  gap: 24px;
  width: min(90vw, 1200px);
  min-width: 800px;
  height: 80vh;

  .form-column {
    width: 45%;
    min-width: 380px;
    padding: 0 24px 24px;
    border-right: 1px solid;
    overflow-y: auto;
    @apply border-slate-100 dark:border-slate-700;
  }

  .scheduled-list-column {
    width: 55%;
    min-width: 420px;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
  }
}

.scheduled-messages {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.scheduled-messages-list {
  flex: 1;
  overflow-y: auto;
  margin-top: 12px;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;

    @apply dark:bg-slate-600;
  }

  scrollbar-width: thin;

  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;

  .dark & {
    scrollbar-color: rgb(71, 85, 105) transparent;
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.3s ease-out;
  max-height: 1000px;
  opacity: 1;
}

.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
  overflow: hidden;
}

.message-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;

  .status-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
  }

  &.status-pending {
    background-color: #fef3c7;
    color: #92400e;

    .status-dot {
      background-color: #92400e;
    }

    @apply dark:bg-yellow-900 dark:text-yellow-200;

    .status-dot {
      @apply dark:bg-yellow-200;
    }
  }

  &.status-sent {
    background-color: #d1fae5;
    color: #065f46;

    .status-dot {
      background-color: #065f46;
    }

    @apply dark:bg-green-900 dark:text-green-200;

    .status-dot {
      @apply dark:bg-green-200;
    }
  }
}

.scheduled-message {
  background: linear-gradient(145deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
  overflow: hidden;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  }

  .message-header {
    padding: 12px 14px;
    cursor: pointer;

    .header-content {
      display: flex;
      flex-direction: column;
      gap: 6px;
    }

    .title-section {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title-and-badge {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      .title {
        font-weight: 500;
        font-size: 13px;
        color: #1a1a1a;
        @apply dark:text-slate-100;
      }

      .expand-icon {
        color: #666;
        @apply dark:text-slate-400;
      }
    }

    .meta-info {
      display: flex;
      align-items: center;
      gap: 12px;
      font-size: 12px;
      color: #666;
      @apply dark:text-slate-400;

      .datetime,
      .inbox,
      .recurrence {
        display: flex;
        align-items: center;
        gap: 4px;

        .icon {
          color: #1f93ff;
        }
      }

      .recurrence {
        .icon {
          color: #10b981;
        }

        .recurrence-text {
          font-weight: 500;
          color: #10b981;
          @apply dark:text-green-400;
        }
      }
    }
  }

  .message-expandable {
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    @apply dark:border-slate-700;
    animation: slideDown 0.2s ease-out;
  }

  .message-preview {
    padding: 12px;
    background-color: rgba(0, 0, 0, 0.02);
    @apply dark:bg-slate-700/30;

    .preview-header {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 6px;
      font-size: 13px;
      font-weight: 500;
      color: #666;
      @apply dark:text-slate-300;

      .preview-icon {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #1f93ff;

        svg {
          width: 14px;
          height: 14px;
        }
      }
    }

    .preview-content {
      padding-left: 20px;
      font-size: 13px;
      line-height: 1.4;
      color: #4a4a4a;
      @apply dark:text-slate-200;
      white-space: pre-wrap;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px;
    background-color: white;
    border-top: 1px solid rgba(0, 0, 0, 0.06);

    .action-button {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 12px;
      border-radius: 6px;
      font-size: 13px;
      font-weight: 500;
      transition: all 0.2s ease;

      &:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }

      &.resend {
        color: #34d399;
      }

      &.edit {
        color: #60a5fa;
      }

      &.delete {
        color: #ff7875;
      }
    }
  }

  .status-badge {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

    &.status-pending {
      background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
      color: #92400e;

      .pulse-dot {
        background-color: currentColor;
      }

      @apply dark:bg-yellow-900/30 dark:text-yellow-300;
    }

    &.status-sent {
      background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
      color: #065f46;

      .pulse-dot {
        background-color: currentColor;
      }

      @apply dark:bg-green-900/30 dark:text-green-300;
    }

    .pulse-dot {
      width: 4px;
      height: 4px;
      border-radius: 50%;
      animation: pulse 2s infinite;
    }
  }
}

@keyframes pulse {
  0% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.4);
  }
  70% {
    transform: scale(1);
    box-shadow: 0 0 0 6px rgba(0, 0, 0, 0);
  }
  100% {
    transform: scale(0.95);
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
  }
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dark {
  .scheduled-message {
    background: linear-gradient(145deg, #1e293b 0%, #0f172a 100%);
    border-color: rgba(255, 255, 255, 0.05);

    .actions {
      background-color: #1e293b;
      border-color: rgba(255, 255, 255, 0.1);

      .action-button {
        &:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }

        &.resend {
          color: #34d399;
        }

        &.edit {
          color: #60a5fa;
        }

        &.delete {
          color: #ff7875;
        }
      }
    }

    .status-badge {
      &.status-pending {
        background: linear-gradient(
          135deg,
          rgba(234, 179, 8, 0.2) 0%,
          rgba(234, 179, 8, 0.3) 100%
        );
        color: #fbbf24;
      }

      &.status-sent {
        background: linear-gradient(
          135deg,
          rgba(16, 185, 129, 0.2) 0%,
          rgba(16, 185, 129, 0.3) 100%
        );
        color: #34d399;
      }
    }
  }
}

::v-deep .modal-container {
  width: auto !important;
  min-width: auto !important;
  max-width: none !important;
  margin: 2rem;
}

.scheduled-messages-header {
  margin-top: 8px;

  .header-content {
    .title-group {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      gap: 8px;

      h3 {
        font-size: 14px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0;

        .counter {
          @apply bg-woot-500 text-white;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 12px;
          font-weight: 500;
          min-width: 24px;
          text-align: center;
          @apply dark:bg-woot-500 dark:text-white;
        }
      }

      .filter-button {
        padding: 4px;
        border-radius: 4px;
        color: #666;
        @apply dark:text-slate-400;

        &:hover {
          @apply bg-slate-100 dark:bg-slate-700;
        }
      }
    }
  }
}

.modal-header {
  padding: 16px 24px;
  border-bottom: 1px solid;
  @apply border-slate-100 dark:border-slate-700;

  .header-content {
    display: flex;
    align-items: center;
    height: 32px;

    .title-group {
      .modal-title {
        font-size: 18px;
        font-weight: 600;
        @apply text-slate-900 dark:text-slate-50;
        white-space: nowrap;
      }
    }
  }
}

.form-group {
  input[type='datetime-local'] {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid;
    @apply border-slate-200 dark:border-slate-600;
    border-radius: 4px;
    font-size: 14px;
    @apply bg-white dark:bg-slate-700;
    @apply text-slate-900 dark:text-slate-100;

    &:focus {
      outline: none;
      @apply border-woot-500;
      box-shadow: 0 0 0 2px rgba(31, 147, 255, 0.1);
    }

    &::-webkit-calendar-picker-indicator {
      filter: invert(0.5);
      @apply dark:invert;
      cursor: pointer;
      opacity: 0.6;

      &:hover {
        opacity: 1;
      }
    }
  }

  textarea {
    min-height: 120px;
    resize: vertical;
    width: 100%;
    padding: 8px 12px;
    border: 1px solid;
    @apply border-slate-200 dark:border-slate-600;
    border-radius: 4px;
    font-size: 14px;
    @apply bg-white dark:bg-slate-700;
    @apply text-slate-900 dark:text-slate-100;

    &:focus {
      outline: none;
      @apply border-woot-500;
      box-shadow: 0 0 0 2px rgba(31, 147, 255, 0.1);
    }
  }

  .checkbox-group {
    margin-top: 8px;
  }

  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    user-select: none;

    .checkbox-input {
      width: 16px;
      height: 16px;
      accent-color: #10b981;
      cursor: pointer;
    }

    .checkbox-text {
      font-size: 14px;
      font-weight: 500;
    }
  }
}

.modal-footer {
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid;
  @apply border-slate-100 dark:border-slate-600;

  .button-wrapper {
    display: flex;
    justify-content: flex-end;
    gap: 8px;

    button {
      min-width: 80px;
    }
  }
}

.delete-confirmation-modal {
  padding: 1.5rem;

  .modal-title {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 1rem;
    @apply text-slate-900 dark:text-slate-100;
  }

  .modal-message {
    @apply text-slate-700 dark:text-slate-300;
  }

  .modal-footer {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid;
    @apply border-slate-100 dark:border-slate-700;

    .button-wrapper {
      display: flex;
      justify-content: flex-end;
      gap: 0.5rem;
    }
  }
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 24px;

  .empty-state-content {
    text-align: center;

    .empty-icon {
      display: block;
      margin: 0 auto 16px auto;
      @apply text-n-blue-10;
    }

    .empty-text {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 8px;
      @apply text-slate-700 dark:text-slate-300;
    }

    .empty-subtext {
      font-size: 13px;
      @apply text-slate-500 dark:text-slate-400;
    }
  }
}

// Estilos para o template selector
.template-selector {
  position: relative;

  .template-loading {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 8px;
    font-size: 12px;
    @apply text-slate-500 dark:text-slate-400;

    .loading-spinner {
      width: 12px;
      height: 12px;
      border: 2px solid;
      border-top-color: transparent;
      border-radius: 50%;
      animation: spin 1s linear infinite;
      @apply border-slate-300 dark:border-slate-600;
    }

    .loading-text {
      font-size: 11px;
    }
  }
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
